import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { AgencyOrganizationsResponse, OrganizationsResponse } from './types';
import { getAgencyOrganizations, getOrganizations, updateOrganizations } from './api';
import { CacheKeys } from 'utils/cacheKeys';
import { setCookie } from 'utils/helperFunctions';

export function useGetOrganizations(
  options?: Omit<UseQueryOptions<OrganizationsResponse, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<OrganizationsResponse>({
    queryKey: ['organizations'],
    queryFn: () => getOrganizations(),
    ...options
  });
}

export function useGetAgencyOrganizations(
  options?: Omit<UseQueryOptions<AgencyOrganizationsResponse, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<AgencyOrganizationsResponse>({
    queryKey: ['agency_organizations'],
    queryFn: () => getAgencyOrganizations(),
    ...options
  });
}

export function useUpdateOrganizations() {
  return useMutation({
    mutationFn: (payload: OrganizationsResponse | FormData) => updateOrganizations(payload),
    onSuccess: (data) => {
      if (data?.configuration?.brand_color) {
        setCookie(CacheKeys.themeColor, data.configuration.brand_color);
        window.location.reload();
      }
      queryClient.invalidateQueries({
        queryKey: ['organizations'],
        refetchType: 'active'
      });
    }
  });
}
